export enum Unit {
    METER = "METER",
    FEET = "FEET"
}